export default __webpack_public_path__ + "static/about4-5f1757d33ddea5ac950ca793df38ddf2.png";